module.exports = __webpack_public_path__ + "static/media/garden-loader.79d1c2c9.gif";